<div class="heading"><h2 mat-dialog-title>Rechnung drucken?</h2></div>
<button mat-icon-button mat-dialog-close class="close-button">
  <mat-icon>close</mat-icon>
</button>
<mat-dialog-content>
  <div class="modal-body">
    <p>Betrag:</p>
    <div class="total-amount-box">
      <h1>{{ this.data.totalAmount | currency: 'EUR': 'symbol' }}</h1>
    </div>
  </div>
  <div class="calculate-change">
    <p>Wechselgeldberechnung (optional)</p>
    <mat-form-field appearance="fill" class="white-outline">
      <mat-label>erhaltener Betrag</mat-label>
      <input matInput type="number" (input)="calculateChange($event)" class="no-arrows no-focus">
    </mat-form-field>
    <p>Wechselgeld: {{ change | currency: 'EUR': 'symbol' }}</p>
    <br>
  </div>
  <p>Soll eine Rechnung gedruckt werden?</p>
</mat-dialog-content>
<mat-dialog-actions align="end" class="button-container">
  <button mat-button [mat-dialog-close]="'yes'" color="primary" class="yes-button"><span>Ja</span></button>
  <button mat-button [mat-dialog-close]="'no'" color="accent" class="no-button"><span>Nein</span></button>
</mat-dialog-actions>
